import React from 'react';
import { connect } from 'react-redux';
import MenuItemChoiceSelection from '../../common/menuitem/MenuItemChoiceSelection';
import { cartItemUpdatePrice } from '../../../actions/cartItem';

import { setPizzaPanel } from '../../../actions/panels';

class ViewSizes extends React.Component {

    constructor(props) {
        super(props);
    }

    printSizePrice(max_toppings, size_id) {
        for (let i = 0; i < this.props.currentLocation.customPizzas.length; i++) {
            if (this.props.currentLocation.customPizzas[i].max_toppings == max_toppings) {
                for (let j = 0; j < this.props.currentLocation.customPizzas[i].prices.length; j++) {
                    if (this.props.currentLocation.customPizzas[i].prices[j].size_id == size_id) {
                        return this.props.currentLocation.customPizzas[i].prices[j].price;
                    }
                }
            }
        }
    }

    render() {
        return (
            <div className="menu-item-window menu-item-list">
                {this.props.currentLocation.pizzaSizes.map((size) => {
                    return (
                        <MenuItemChoiceSelection
                            onChoicePress={() => { 
                                this.props.dispatch(cartItemUpdatePrice(size.id, size.size_name, 0));
                                this.props.dispatch(setPizzaPanel('info'));
                            }}
                        >
                            {size.size_name} - {this.printSizePrice(this.props.cartItem.max_toppings, size.id)}
                        </MenuItemChoiceSelection>
                    );
                })}
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        cartItem: state.cartItem,
        currentLocation: state.currentLocation.info,
    };
};

export default connect(mapStateToProps)(ViewSizes);
